module.exports = __webpack_public_path__ + "media/cursor_move.861b17da.wav";